import { refinementList } from 'instantsearch.js/es/widgets'
import { refinementListItemTemplate } from './refinementTemplates'

function validAffinities () {
  return ['vibe_names', 'year_of_manufacture', 'main_material_name', 'color_name']
}

// Revisit this later Rui
function getPersonalisedAffinities () {
  if (!window.neuralPersoAffinities) return []
  const filteredAffinities = window.neuralPersoAffinities.filter(record => validAffinities().includes(record.name))
  return filteredAffinities
}

function recommendedFacets (attributeName, personalisedAffinities, facetItems) {
  const filteredAffinities = personalisedAffinities.slice(0, 5) // take top 5 scored
  const affinitiesWithFacetInfo = filteredAffinities
    .filter(record => record.name === attributeName) // select the facetItems the user has affinity with
    .map(affinity => {
      const matchingItem = facetItems.find(item => item.value === affinity.value)
      if (matchingItem) {
        // If a matching item is found, merge the data
        return { ...matchingItem, score: affinity.score }
      } else {
        return null
      }
    })
  return affinitiesWithFacetInfo.filter(record => record !== null)
}

// generates array of `refinementList` for each filter type the user has affinities with
export function recommendedFilters (containerPrefix) {
  const personalisedAffinities = getPersonalisedAffinities()
  const personalisedAffinityNames = personalisedAffinities.map(item => item.name)
  const uniqueAffinityNames = [...new Set(personalisedAffinityNames)]

  return uniqueAffinityNames.map(affinityName => {
    return refinementList({
      container: `#vjs-${containerPrefix}-recommended-${affinityName}`,
      attribute: affinityName,
      // affinity score not standard Algolia, added in transformItems, comes from NeuralPerso
      sortBy: ['score:desc', 'name:asc'],
      operator: 'or',
      showMore: false,
      limit: 100,
      templates: {
        item (hit) {
          return refinementListItemTemplate(hit)
        }
      },
      transformItems (items) {
        return recommendedFacets(affinityName, personalisedAffinities, items)
      }
    })
  })
}
